const SCRIPT_ID = 'revokonek-webchat';

/** Locates the embed script tag that loaded the widget bundle. */
export function findEmbedScript(): HTMLScriptElement | null {
  const byWidgetId = document.querySelector('script[data-widget-id]');
  if (byWidgetId instanceof HTMLScriptElement) {
    return byWidgetId;
  }

  const byId = document.getElementById(SCRIPT_ID);
  if (byId instanceof HTMLScriptElement) {
    return byId;
  }

  const current = document.currentScript;
  if (current instanceof HTMLScriptElement) {
    return current;
  }

  const withKey = document.querySelectorAll<HTMLScriptElement>(
    'script[data-public-key], script[data-widget-id]',
  );
  if (withKey.length > 0) {
    return withKey[withKey.length - 1] ?? null;
  }

  const bySrc = document.querySelectorAll<HTMLScriptElement>(
    'script[src*="widget.js"]',
  );
  return bySrc[bySrc.length - 1] ?? null;
}

/** Derives the Revocom API origin from the widget script URL. */
export function apiUrlFromScriptSrc(
  script: HTMLScriptElement | null,
): string | undefined {
  if (!script?.src) {
    return undefined;
  }

  try {
    const url = new URL(script.src, window.location.href);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return undefined;
    }
    return url.origin;
  } catch {
    return undefined;
  }
}

export function resolvePublicKey(
  script: HTMLScriptElement | null,
): string | undefined {
  const fromScript = script?.dataset.publicKey?.trim();
  const fromWindow = window.Revocom?.widgetId?.trim();
  const fromQuery = new URLSearchParams(window.location.search)
    .get('publicKey')
    ?.trim();

  return fromScript || fromWindow || fromQuery || undefined;
}

export function resolveGrowthWidgetId(
  script: HTMLScriptElement | null,
): string | undefined {
  const fromScript = script?.dataset.widgetId?.trim();
  const fromQuery = new URLSearchParams(window.location.search)
    .get('widgetId')
    ?.trim();
  return fromScript || fromQuery || undefined;
}
